var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRibbon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_4338_61643",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.413086H20L16.3303 5.00024L20 9.5874H0L3.66972 5.00024L0 0.413086Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.413086V-1.08691H-3.12094L-1.1713 1.35013L0 0.413086ZM20 0.413086L21.1713 1.35013L23.1209 -1.08691H20V0.413086ZM20 9.5874V11.0874H23.1209L21.1713 8.65036L20 9.5874ZM0 9.5874L-1.1713 8.65036L-3.12094 11.0874H0V9.5874ZM16.3303 5.00024L15.159 4.0632L14.4093 5.00024L15.159 5.93728L16.3303 5.00024ZM3.66972 5.00024L4.84103 5.93728L5.59066 5.00024L4.84103 4.0632L3.66972 5.00024ZM0 1.91309H20V-1.08691H0V1.91309ZM20 8.0874H0V11.0874H20V8.0874ZM18.8287 -0.523957L15.159 4.0632L17.5016 5.93728L21.1713 1.35013L18.8287 -0.523957ZM15.159 5.93728L18.8287 10.5244L21.1713 8.65036L17.5016 4.0632L15.159 5.93728ZM1.1713 10.5244L4.84103 5.93728L2.49842 4.0632L-1.1713 8.65036L1.1713 10.5244ZM4.84103 4.0632L1.1713 -0.523957L-1.1713 1.35013L2.49842 5.93728L4.84103 4.0632Z",
    fill: "#2B2B35",
    mask: "url(#path-1-inside-1_4338_61643)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbon);
export default __webpack_public_path__ + "static/media/ribbon.c399057efb2eb9da243e28afac8d5669.svg";
export { ForwardRef as ReactComponent };